/**
 * GET /v1/incidents/active — returns the current ACTIVE incident for
 * the school, or null. Polled by mobile + web for the live banner.
 */

import { z } from 'zod'

import { IncidentSchema } from '../../schemas/entities/incident'

export const ListActiveIncidentResponseSchema = z.object({
  data: IncidentSchema.nullable()
})
export type ListActiveIncidentResponse = z.infer<typeof ListActiveIncidentResponseSchema>
